import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  style: {"width":"100%","height":"100%"}
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<path fill=\"currentColor\" d=\"M0 11.03a2 2 0 0 1 .838-1.628l12-8.572a2 2 0 0 1 2.325 0l12 8.572A2 2 0 0 1 28 11.029V26a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V11.03Z\"></path><rect fill=\"currentColor\" x=\"4\" y=\"18\" width=\"2\" height=\"6\" rx=\"1\"></rect><defs fill=\"currentColor\"><linearGradient fill=\"currentColor\" id=\"a\" x1=\"13.941\" y1=\"6.289\" x2=\"13.941\" y2=\"28\" gradientUnits=\"userSpaceOnUse\"><stop fill=\"currentColor\" stop-color=\"#8BB2FF\"></stop><stop fill=\"currentColor\" offset=\"1\" stop-color=\"#2168F6\"></stop></linearGradient></defs>", 3)
const _hoisted_5 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    class: "tri-icon",
    style: _normalizeStyle(`font-size: ${_ctx.size}; color: ${_ctx.color}; width: 1em; height: 1em; display:block; line-height: 0;`)
  }, [
    (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_5))
  ], 4))
}